import { render } from "./Jokes.vue?vue&type=template&id=fb181a6a&scoped=true"
import script from "./Jokes.vue?vue&type=script&lang=js"
export * from "./Jokes.vue?vue&type=script&lang=js"

import "./Jokes.vue?vue&type=style&index=0&id=fb181a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb181a6a"]])

export default __exports__